import api from './client'
import { Course, Enrollment, CreateCourseData, ApiResponse, PaginatedResponse } from '../types'

export const getCourses = async () => {
  const response = await api.get('/courses/')
  return response.data
}

export const getCourseById = async (courseId: string): Promise<ApiResponse<Course>> => {
  const response = await api.get(`/courses/${courseId}/`)
  
  // If response.data is already the course object (not wrapped), wrap it
  if (response.data && !response.data.data && response.data.id) {
    return {
      data: response.data,
      success: true
    }
  }
  
  return response.data
}

export const createCourse = async (courseData: CreateCourseData): Promise<ApiResponse<Course>> => {
  const response = await api.post('/courses/', courseData)
  return response.data
}

export const updateCourse = async (courseId: string, courseData: Partial<CreateCourseData>): Promise<ApiResponse<Course>> => {
  const response = await api.patch(`/courses/${courseId}/`, courseData)
  return response.data
}

export const deleteCourse = async (courseId: string): Promise<ApiResponse<null>> => {
  const response = await api.delete(`/courses/${courseId}/`)
  return response.data
}

export const getUserEnrollments = async (): Promise<ApiResponse<Enrollment[]>> => {
  // Use only_mine=true to efficiently get only current user's enrollments from backend
  const response = await api.get<PaginatedResponse<Enrollment>>('/user-enrollments/?only_mine=true')
  return { data: response.data.results, success: true }
}

export const enrollInCourse = async (courseId: string): Promise<ApiResponse<Enrollment>> => {
  const response = await api.post(`/courses/${courseId}/enroll/`)
  return response.data
}

export const updateEnrollmentProgress = async (
  enrollmentId: string, 
  progress: number
): Promise<ApiResponse<Enrollment>> => {
  const response = await api.patch(`/user-enrollments/${enrollmentId}/`, { progress })
  return response.data
}

export const uploadCertificate = async (
  enrollmentId: string, 
  certificateFile: File
): Promise<ApiResponse<Enrollment>> => {
  const formData = new FormData()
  formData.append('certificate', certificateFile)
  
  const response = await api.post(`/enrollments/${enrollmentId}/upload-certificate/`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
  return response.data
}

export const completeCourseItemByItem = async (
  courseItemId: number,
  userEnrollmentId?: number
): Promise<ApiResponse<any>> => {
  const response = await api.post(`/course-item-progress/complete-by-item/`, {
    course_item_id: courseItemId,
    user_enrollment_id: userEnrollmentId
  })
  return response.data
}
